import type { Middleware } from '@reduxjs/toolkit'
import { setCallActive, setCallMinimized, setCallScope, WHEREBY_SESSION_KEY } from '../slices/wherebySlice'

// Persist call state (incl. the pinned callScope) so a refresh resumes the same room.
export const wherebyPersistMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action)

  if (setCallActive.match(action) || setCallMinimized.match(action) || setCallScope.match(action)) {
    const { whereby } = store.getState()
    if (!whereby.isCallActive) {
      try {
        sessionStorage.removeItem(WHEREBY_SESSION_KEY)
      } catch {}
    } else {
      try {
        const existing = JSON.parse(sessionStorage.getItem(WHEREBY_SESSION_KEY) ?? '{}')
        sessionStorage.setItem(
          WHEREBY_SESSION_KEY,
          JSON.stringify({
            startedAt: existing.startedAt ?? Date.now(),
            isCallActive: true,
            isCallMinimized: whereby.isCallMinimized,
            callScope: whereby.callScope
          })
        )
      } catch {}
    }
  }

  return result
}
